import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { CategoryCard } from './style'
import { getOndemandCategory } from '../../../redux/actions'
import { EventPointsWrapper } from '../../MainEvents/styles'
import LazyImage from '../../common/LazyImage/LazyImage'
import { ImageUrl } from '../../../utils/constants'
import { t } from 'i18next'
import { 
  LearningGrowthIcon, 
  CommunityGivingIcon, 
  HeartHealthIcon, 
  DEIIcon, 
  Healthicon, 
  NutritionIcon, 
  SelfImprovementIcon, 
  EngagementCultureIcon, 
  StressIcon, 
  StressManagementIcon, 
  WeightLossIcon, 
  BenefitsIcon 
} from '../../../utils/icons'

// ICON MAP
const categoryIconMap = {
  medical: Healthicon,
  nutrition: NutritionIcon,
  workplace: BenefitsIcon,
  fitness: LearningGrowthIcon,
  lifestyle: DEIIcon,
  stress: StressIcon,
  "Stress Management": StressManagementIcon,
  "Healthy Habits": CommunityGivingIcon,
  "Heart Health": HeartHealthIcon,
  "Self-Improvement": SelfImprovementIcon,
  "Social Wellbeing": EngagementCultureIcon,
  "Weight Loss": WeightLossIcon,
};

// BACKGROUND COLOR MAP
const categoryColorMap = {
  medical: "#FCF2F3",
  nutrition: "#F1F8F2",
  workplace: "#F2F5FB",
  fitness: "#FCF7F0",
  lifestyle: "#F5F6E8",
  stress: "#FAF5F8",
  "Stress Management": "#FCF7F0",
  "Healthy Habits": "#F1F8F2",
  "Heart Health": "#FCF2F3",
  "Self-Improvement": "#F5F6E8",
  "Social Wellbeing": "#FBF4F9",
  "Weight Loss": "#F2F5FB",
};

// NEW BORDER COLOR MAP
const categoryBorderColorMap = {
  medical: "#E5B9BD",
  nutrition: "#A4D6A8",
  workplace: "#B5C6E3",
  fitness: "#F1D8B4",
  lifestyle: "#D6D9A4",
  stress: "#E3B8CE",
  "Stress Management": "#F1D8B4",
  "Healthy Habits": "#A4D6A8",
  "Heart Health": "#E5B9BD",
  "Self-Improvement": "#D6D9A4",
  "Social Wellbeing": "#E3B8CE",
  "Weight Loss": "#B5C6E3",
};

const EventsCategory = ({ ondemandCategory, fetchOndemandCategory, history }) => {

  useEffect(() => {
    fetchOndemandCategory();
  }, []);

  return (
    <EventPointsWrapper margin gap={"12px 8px"}>
      {ondemandCategory?.length > 0 &&
        ondemandCategory.map((category, index) => {
          if (category.video_count <= 0) return null;

          const trimmedName = category.category_name?.trim();

          const IconComponent = categoryIconMap[trimmedName];
          const bgColor = categoryColorMap[trimmedName] || "#f2f2f2";
          const borderColor = categoryBorderColorMap[trimmedName] || "#DCDCDC";

          return (
            <CategoryCard
              key={index}
              style={{
                border: `0.75px solid #dcdcdc`,
                width: "calc((100% - 35px) / 4)"
              }}
              isCardRadius={"12px"}
              cardHeight="72px"
              isBorderRadius={"4px"}
              cardPadding={"12px 8px"}
              background={bgColor}
              onClick={() => {
                history.push({
                  pathname: `/company/events/library/ondemand/${category.id}`,
                  state: { category: category.name },
                });
              }}
            >
              {IconComponent ? (
                <div className="icon" style={{ border: `1px solid ${borderColor}`,}}>
                  <IconComponent />
                </div>
              ) : (
                <LazyImage div="icon" src={`${ImageUrl}/${category.new_icon}`} />
              )}

              <div className="name" title={t(category.name)}>
                {t(category.name)}
              </div>
            </CategoryCard>
          );
        })}
    </EventPointsWrapper>
  );
};

EventsCategory.propTypes = {
  history: PropTypes.object,
  companyId: PropTypes.number,
  ondemandCategory: PropTypes.array,
  fetchOndemandCategory: PropTypes.func
};

const mapStateToProps = (state) => ({
  ondemandCategory: state.events.ondemandCategory,
});

const mapDispatchToProps = (dispatch) => ({
  fetchOndemandCategory: () => dispatch(getOndemandCategory()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EventsCategory));
